export interface IRobloxTopChartsMetricOption {
  value: string;
  labelKey: string;
  hoverTipsKey: string;
}

/** PCU 指标字段 */
export const ROBLOX_TOP_CHARTS_PCU_METRIC = 'roblox__pcu';

export const ROBLOX_TOP_CHARTS_PCU_LABEL_KEY = 'dbi_roblox_top_charts_metric_pcu';

/** Server Size 取 max_players 指标 */
export const ROBLOX_TOP_CHARTS_SERVER_SIZE_METRIC = 'roblox__max_players';

/** 表格展示用，不支持排序 */
export const ROBLOX_TOP_CHARTS_SERVER_SIZE_COLUMN = {
  columnKey: 'server_size',
  metric: ROBLOX_TOP_CHARTS_SERVER_SIZE_METRIC,
  labelKey: 'dbi_roblox_server_size',
  hoverTipsKey: 'dbi_roblox_server_size_tip',
  valueOnly: true,
};

/** 表格数值指标列（不含 PCU、Server Size） */
export const ROBLOX_TOP_CHARTS_TABLE_METRIC_OPTIONS: IRobloxTopChartsMetricOption[] = [
  {
    value: 'roblox__favorite_number',
    labelKey: 'dbi_roblox_top_charts_metric_favorites',
    hoverTipsKey: 'dbi_roblox_top_charts_metric_favorites_tip',
  },
  {
    value: 'roblox__visit_number',
    labelKey: 'dbi_roblox_top_charts_metric_visits',
    hoverTipsKey: 'dbi_roblox_top_charts_metric_visits_tip',
  },
  {
    value: 'roblox__like_number',
    labelKey: 'dbi_roblox_top_charts_metric_likes',
    hoverTipsKey: 'dbi_roblox_top_charts_metric_likes_tip',
  },
  {
    value: 'roblox__unlike_number',
    labelKey: 'dbi_roblox_top_charts_metric_dislikes',
    hoverTipsKey: 'dbi_roblox_top_charts_metric_dislikes_tip',
  },
];

/** @deprecated 使用 ROBLOX_TOP_CHARTS_TABLE_METRIC_OPTIONS */
export const ROBLOX_TOP_CHARTS_METRIC_OPTIONS = ROBLOX_TOP_CHARTS_TABLE_METRIC_OPTIONS;

export const ROBLOX_TOP_CHARTS_DEFAULT_SORT_METRIC = ROBLOX_TOP_CHARTS_PCU_METRIC;

export const ROBLOX_TOP_CHARTS_CHART_METRIC = ROBLOX_TOP_CHARTS_PCU_METRIC;

export const ROBLOX_TOP_CHARTS_METRIC_VALUES = [
  ROBLOX_TOP_CHARTS_PCU_METRIC,
  ROBLOX_TOP_CHARTS_SERVER_SIZE_METRIC,
  ...ROBLOX_TOP_CHARTS_TABLE_METRIC_OPTIONS.map((item) => item.value),
];

export const getRobloxMetricRatioKey = (metricKey: string): string =>
  `${metricKey}_ratio`;
